<template>
    <section class="flex flex-col lg:flex-row items-center xl:px-10 lg:px-8 md:px-8 px-2 py-8 md:py-10 xl:py-10 bg-[#186a85] text-white relative overflow-hidden font-poppins antialiased ">
  <img src="@/assets/bg.5.svg" alt="" class="absolute top-0 left-0 z-10">
  <!-- Text Content (Kiri) -->
  <div class="w-full px-6 md:px-12 lg:px-16 text-start relative">
    <div class="flex items-center justify-start mb-4">
      <div class="h-7 rounded-lg w-1 bg-gray-100"></div>
      <span class="px-2 py-2 bg-opacity-20 text-gray-100 font-sm text-md tracking-wider">About us</span>
    </div>
    <h1 class="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
      Welcome to PHISOFT
    </h1>
    <h3 class="text-lg font-normal mb-4">
      by PSG Group
      <span class="block w-16 h-0.5 bg-gradient-to-r from-[#186a85]/70 to-transparent mt-1"></span>
    </h3>
    <p class="text-white text-sm md:text-sm lg:text-md xl:text-md leading-relaxed xl:text-justify">
      PHISOFT is a tech company not only a software house. We focus on manufacturing and development of the technology and provide technology as a service.
    </p>

    <!-- Button -->
    <router-link to="/about"
      class="mt-8 inline-flex items-center px-6 py-2 bg-white text-[#186a85] border-2 border-white font-medium rounded-full shadow-lg hover:bg-white hover:text-[#186a85] transition-all duration-300 hover:scale-105 text-sm md:text-base group relative overflow-hidden">
      <span class="relative z-10">Read More</span>
      <div class="absolute inset-0 w-0 bg-white group-hover:w-full transition-all duration-300 ease-in-out"></div>
    </router-link>
  </div>

  <!-- Image Content (Kanan) -->
  <div class="w-full flex justify-center items-center">
    <img src="@/assets/welcome.svg" alt="Welcome Image" class="w-full">
  </div>
</section>
</template>

